import { Modal } from "../components/Modal";

import { readFrameMeta } from "./frameMeta";

import type { ExcalidrawElement } from "@excalidraw/excalidraw/element/types";

export type GroupSealModalProps = {
  frames: readonly (ExcalidrawElement & { name?: string | null })[];
  onToggle(frameId: string, sealed: boolean): void;
  onClose(): void;
};

/**
 * Group frames have no owner (membership changes every lesson), so there is
 * no "my frame" to bind a header seal button to. Anyone opens this instead
 * and toggles any group directly — no confirmation, since it's already
 * behind a deliberate open.
 */
export const GroupSealModal = ({
  frames,
  onToggle,
  onClose,
}: GroupSealModalProps) => (
  <Modal
    title="모둠 마감"
    primaryLabel="확인"
    onPrimary={onClose}
    onCancel={onClose}
  >
    <ul className="canvaschool-group-seal-list">
      {frames.map((frame) => {
        const sealed = readFrameMeta(frame).sealed !== null;
        const label = frame.name?.trim() || "모둠";
        return (
          <li key={frame.id} className="canvaschool-group-seal-row">
            <span>{label}</span>
            <button
              type="button"
              aria-pressed={sealed}
              aria-label={sealed ? `${label} 마감 풀기` : `${label} 마감하기`}
              onClick={() => onToggle(frame.id, sealed)}
            >
              {sealed ? "마감 풀기" : "마감하기"}
            </button>
          </li>
        );
      })}
    </ul>
  </Modal>
);
